module.exports = __webpack_public_path__ + "img/icomoon.744ba5de.svg";